module.exports = __webpack_public_path__ + "img/electric_pending_zone_selected.c1464883.svg";